import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { RootState } from '../../store';
import { clearNotifications, notificationsSelectors, removeNotification } from '../../store/UI/notifications.slice';
import { NgNotification, StyledNotificationsList } from '../UI';

export const NotificationsList = () => {
  const dispatch = useDispatch();
  const notifications = useSelector((state: RootState) =>
    notificationsSelectors.getNotificationsByKey(state, 'global'),
  );

  const handleClose = (notification: any) => {
    dispatch(removeNotification({ key: 'global', notificationId: notification.id }));
  };

  useEffect(() => {
    return () => {
      dispatch(clearNotifications({ key: 'global' }));
    };
  }, [dispatch]);

  return (
    <StyledNotificationsList>
      {notifications.map((notification) => (
        <NgNotification key={notification.id} notification={notification} onClose={handleClose} />
      ))}
    </StyledNotificationsList>
  );
};
